export const postProcessMarkdown = (markdown?: string): string | undefined => {
    if (!markdown) {
        return markdown;
    }

    // Adds double spaces for a linebreak
    const postMarkdown = markdown.replace(/(.+?)( *\n)/g, '$1  \n');

    return postMarkdown;
};
